import React from 'react';

import * as Fields from './Fields';
import * as normalizers from './normalizers';
import * as m from '../../messages';
import { TranslatedMessage } from 'common/components/Intl';

const SSNFieldGroup = ({ disabled, optOutEnabled }) => (
  <div className="AddressForm__group">
    <div className="subhead navy">
      <TranslatedMessage id={m.SSN_TITLE} />
    </div>

    <p className="text flat-blue">
      <TranslatedMessage id={m.SSN_DESCRIPTION} />
    </p>

    <div className="row">
      <div className="col-xs-12">
        <div className="AddressForm__ssn">
          <div>###</div>
          <div className="AddressForm__ssn-separator">-</div>
          <div>##</div>
          <div className="AddressForm__ssn-separator">-</div>
          <div className="AddressForm__ssn-input">
            <Fields.SSN
              normalize={normalizers.maxDigits(4)}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="AddressForm_ssn-optout">
          {optOutEnabled && <Fields.SSNOptOut />}
        </div>
      </div>
    </div>
  </div>
);

export default SSNFieldGroup;



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/SSNFieldGroup.js